package com.hyperether.planner.model

data class Plan(
    val person: String,
    val events: MutableList<Event> = mutableListOf()
)
